import config from "../../config";
import Api from "./Api";
import Config from "../../config";
import ErrorCode from "../constants/ErrorCode";
import eventBus from "../utils/EventBus";
import {getUrlAndMethod, getUrlAndMethodv2} from "./URLGenerator";
import {_alert} from "../../actions/Alert";
import T from "../../shared/component/t/T";
import {_loading} from "../../actions/Loading";
import {Store} from '../../app/Store';
import Storage from "../../helpers/Storage";

class BaseApi {

    api = new Api();
    point = "";

    constructor() {
        try {
            this.point = BaseApi.getVersion() + '/' + this.getResource();
        } catch (error) {
            this.point = "";
        }
    }

    find(data = {}) {
	    console.log('find', this.point.split('/')?.[1], data)
		return this.fullFetch(this.point, 'get', {data})
        // this.api.setPoint(this.point);
        // return this.api.send('get', data).then((response) => {
        //     return new Promise((resolve, reject) => {
        //         resolve(response);
        //     });
        // }).catch((error) => {
        //     return new Promise((resolve, reject) => {
        //         // * Here server tells us that user`s session is expired and has to login again.
        //         if (error?.response?.data?.status === ErrorCode.EXPIRED) {
	    //             // window.location.href = '/signin';
	    //             eventBus.dispatchEvent("sessionExpired");
        //         } else if (error?.response?.data?.status === ErrorCode.TERMINATED) {
        //             window.location.href = '/signin';
        //         } else {
        //             reject(error);
        //         }
        //     });
        // });
    }

    // create(data = null) {
	//     // console.log('create', this.point, data)
	// 	// return this.fullFetch(this.point, 'post', {data})
    //     this.api.setPoint(this.point);
    //     return this.api.send('post', data).then((response) => {
    //         return new Promise((resolve, reject) => {
    //             resolve(response);
    //         });
    //     }).catch((error) => {
    //         return new Promise((resolve, reject) => {
    //             reject(error);
    //         });
    //     });
    // }

    customCreate(data = null, config = null) {
        if (!config) {
            throw new Error("Wrong config to method customCreate!!!");
        }

        let {entity, action} = config;
	    console.log('customCreate', entity, action, data)
	    return this.fullFetch(entity, action, {data});
		
	    // let {url, method} = getUrlAndMethod(entity, action);

        // this.point = url;
        // this.api.setPoint(this.point);
        // return this.api.send(method, data).then((response) => {
        //     return new Promise((resolve, reject) => {
        //         resolve(response);
        //     });
        // }).catch((error) => {
        //     return new Promise((resolve, reject) => {
        //         reject(error);
        //     });
        // });
    }

    customJustReturnURL = (config = null) => {
        if (!config) {
            throw new Error("Wrong config to method customCreate!!!");
        }

        let {entity, action} = config;
        let {url} = getUrlAndMethod(entity, action);
        return url;
    }

    // update(data = null) {
	//     // console.log('update', this.point, data)
	//     // debugger
	// 	// return this.fullFetch(this.point, 'put', {data: data})
    //     this.api.setPoint(this.point);
    //     return this.api.send('put', data).catch((error) => {
    //         return new Promise((resolve, reject) => {
    //             reject(error);
    //         });
    //     });
    // }

    // delete(data = null) {
	//     // console.log('delete', this.point, data)
	// 	// return this.fullFetch(this.point, 'delete', {data})
    //     this.api.setPoint(this.point);
    //     return this.api.send('delete', data);
    // }
	
	pushMessageConfirmation = (id) => {
		let baseApi = new BaseApi()
		baseApi.fullFetch('login', 'put', {data: {push_message_id_to_mark_as_read: id}})
			.then(()=>{ Store.dispatch(_alert(false, null, "")) })
	}

	fullFetch(controller = null, req_method = null) {
		let data = arguments[2]?.data ?? null
		let showMessageSuccess = arguments[2]?.showMessageSuccess ?? false
		let showMessageFailed = arguments[2]?.showMessageFailed ?? true
		let version = arguments[2]?.version ?? 1
        let responseType = arguments[2]?.responseType ?? undefined
        let stopLoading = arguments[2]?.stopLoading ?? true

		if (!controller || !req_method) {
            throw new Error("Wrong configs for fullFetch function!!!");
		}
		let {url, method} = version === 1 ? getUrlAndMethod(controller, req_method) : getUrlAndMethodv2(controller, req_method)

		this.point = url;
		this.api.setPoint(this.point);

        // Wrap the entire Promise chain in another Promise
        return new Promise((resolve, reject) => {
            this.api
                .send(method, data, responseType)
                .then((response) => {
					if (response?.data?.push_messages?.[0]){
						let pushMsg = response?.data?.push_messages?.pop()
                        Store.dispatch(_alert(true, pushMsg?.type, pushMsg?.message,
	                        !pushMsg?.requires_confirmation, pushMsg?.requires_confirmation, !pushMsg?.requires_confirmation,
	                        pushMsg?.requires_confirmation ? ()=>this.pushMessageConfirmation(pushMsg?.id) : null
                        ));
					}
                    if (showMessageSuccess) {
                        let responseMessage = response?.data;
                        Store.dispatch(_alert(true, "success", responseMessage?.reason ?? responseMessage?.msg ?? responseMessage?.message));
                    }
                    resolve(response);
                })
                .catch((error) => {
                    if (error?.code === "ERR_NETWORK") {
	                    Store.dispatch(_alert(true, "error", <T token={"network_error"}/>, true, true));
                    } else if (error?.response?.data?.status === ErrorCode.EXPIRED) {
	                    Storage.setTicketTimeFails()
	                    window.location.reload()
	                } else if (error?.response?.data?.status === ErrorCode.TERMINATED) {
	                    Storage.removeStorageData()
	                    eventBus.dispatchEvent("sessionExpired");
                    } else if (showMessageFailed) {
                        let errorMessage = error.response?.data;
                        console.log(errorMessage?.reason || errorMessage?.msg || errorMessage?.message || errorMessage);
                        Store.dispatch(_alert(true, "error", errorMessage?.reason || errorMessage?.msg || errorMessage?.message || errorMessage));
                    }
                    reject(error);
                })
                .finally(() => {
                    if (stopLoading){
                        Store.dispatch(_loading(false));
                    }
                });
        });
	}

	static getVersion() {
		return 1;
	}

    static serverAddress() {
        return config.baseUrl;
    }

    static getLanguage() {
        switch (Config.lang) {
            case 'fa':
                return 'fa_IR';
            case 'en':
                return 'en_US';
            default:
                return 'fa_IR';
        }
    }

}


export default BaseApi;